import uiux from './uiux.png'
import web from './web.png'
import prog from './prog.png'

export const Tools =[
    {
        _id:1,
        name:"Figma",
        level:"Advances",
    },
    {
        _id:2,
        name:"Git",
        level:"Advances",
    },
    {
        _id:3,
        name:"Canva",
        level:"Intermediate",
    },
    {
        _id:5,
        name:"Excel",
        level:"Advance",
    },
    {
        _id:6,
        name:"PowerBI",
        level:"Advance",
    }
]
export const langu =[
    {
        _id:1,
        name:"Java",
        level:"Intermediate"
    },
    {
        _id:2,
        name:"Python",
        level:"Intermediate"
    },
    {
        _id:3,
        name:"MERN STACK",
        level:"Advance"
    },
    {
        _id:4,
        name:"MySQL",
        level:"Advance"
    },
    {
        _id:5,
        name:"PHP",
        level:"Intermediate"
    },
    {
        _id:6,
        name:"Django",
        level:"Basic"
    },
]
export const serviceData = [
    {
        _id:0,
        img:prog,
        title:"Software Developer",
        content:"Building robust,effcient applicatons with a focus on clean code,scalability, and seamless integration for diverse software development."
    },
    {
        _id:1,
        img:web,
        title:"Web Developer",
        content:"Create clean,responsive websites that are visually appealing and user-friendly,ensuring seamless experiences across all devices and platforms."
    },
    {
        _id:2,
        img:uiux,
        title:"UI/UX Design",
        content:"Desgining intutive,visually appealing interfaces that priorotize user experience through thoughtful layouts,responsive designs and seamless interaction."
    },
]